import { ConvertedImage, OneShotBinary, NodeWithSize } from '../types';

import { ChallengeSaveError } from '../../types';

const getConstraint = (
  scale: number | boolean,
  node: NodeWithSize
): ExportSettingsConstraints | undefined => {
  if (scale === false) return;
  if (!scale || typeof scale !== 'number') return;
  if (node.width * scale < 2000 && node.height * scale < 2000)
    return {
      type: 'SCALE',
      value: scale,
    };

  if (node.width > node.height)
    return {
      type: 'WIDTH',
      value: 2000,
    };

  return {
    type: 'HEIGHT',
    value: 2000,
  };
};

/**
 * nodeContentOnly - determining whether other layers overlapping with node will be exported (or partially exported)
 */
export const getImageForNode = async (
  node: NodeWithSize,
  nodeContentOnly = false,
  scale?: number | boolean
): Promise<ConvertedImage | ChallengeSaveError> => {
  try {
    const converted = await node.exportAsync({
      format: 'PNG',
      useAbsoluteBounds: true,
      contentsOnly: nodeContentOnly,
      constraint: getConstraint(typeof scale === 'undefined' ? 1 : scale, node),
    });

    return { converted: new OneShotBinary(converted) };
  } catch {
    return {
      type: 'UNABLE_TO_GENERATE_IMAGE',
      nodeId: node.id,
      nodeName: node.name,
    };
  }
};
